
$(document).ready(function () {
  
  // To select First model on  page load

  var checkInterval = setInterval(function () {
    var modelLength = $(".product-v2 .model-box-outer-1");
    if (modelLength.length) {
      $(".OrderSummary").addClass("active");
      $(".product-form__buttons").addClass("active");
      modelLength.trigger("click");
      clearInterval(checkInterval);
    }
  }, 200);

  // first section on homepage start
  var scrollTimeout;

  $(".layout__heroslide").scroll(function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      var windowHeight = $(".layout__heroslide").height();
      var scrollTop = $(this).scrollTop();
      var isActive = false; // Flag to track if any .reverse_header is in view

      $(".reverse_header").each(function () {
        var slideTop = $(this).offset().top;
        var slideHeight = $(this).outerHeight();

        if (
          scrollTop > slideTop - windowHeight &&
          scrollTop < slideTop + slideHeight
        ) {
          isActive = true;
          return false; // Exit the loop early if any .reverse_header is in view
        }
      });

      if (isActive) {
        $("body").addClass("active");
      } else {
        $("body").removeClass("active");
      }
    }); // Adjust debounce delay as needed
    // }, 100);  Adjust debounce delay as needed
  });

  // first section on homepage end

  // ====================================

  // for tansition for header start

  var scrollTimeout2;
  // $(".heroslide-parallax:first-child").addClass("animation");
  $(".layout__heroslide").scroll(function () {
    clearTimeout(scrollTimeout2);
    scrollTimeout2 = setTimeout(function () {
      var windowHeight = $(".layout__heroslide").height();
      var scrollTop = $(this).scrollTop();
      var isActive = false; // Flag to track if any .reverse_header is in view

      $(".heroslide-parallax").each(function () {
        var slideTop = $(this).offset().top;
        var slideHeight = $(this).outerHeight();

        if (
          scrollTop > slideTop - windowHeight &&
          scrollTop < slideTop + slideHeight
        ) {
          $(this).addClass("animation");
          // var html = $(this).prop('outerHTML');
          //  $('.all_slide_data').html(html);
        } else {
          $(this).removeClass("animation");
        }
      });
    }, 100); // Adjust debounce delay as needed
  });

  $("li header-menu").hover(
    function () {
      $(".header").addClass("active-header");
      // $('.animate_navigation-wrapper').addClass('outerNav_open');
    },
    function () {
      $(".header").removeClass("active-header");
      // $('.animate_navigation-wrapper').removeClass('outerNav_open');
    }
  );

  //   $(".nav_list .mega-menu").hover(
  //     function () {
  //      var list_value =  $(this).attr('data-li');
  //      $('.animate_navigation-wrapper .mega-menu[data-li="'+list_value+'"]').addClass('open_content');
  //     },
  //     function () {
  //      $('.animate_navigation-wrapper .mega-menu').removeClass('open_content');
  //     }
  // );

  // for tansition for header start

  // ====================================

  // login page functionality start
  $("#CustomerEmail").on("input change", function () {
    var inputText = $(this).val();
    if (inputText.trim() !== "") {
      $(".next_step_pass").removeClass("btn-disabled");
    } else {
      $(".next_step_pass").addClass("btn-disabled");
    }
  });

  $(document).on("click", "#customer_login .next_step_pass", function () {
    var email = $("#CustomerEmail").val(); // Include '#' for id selector
    console.log(email.length);
    if (email.length > 0) {
      $(".loader_outer").show(); // Show loader when button is clicked
      setTimeout(function () {
        $(".loader_outer").hide(); // Hide loader after 2 seconds
      }, 500);
      $(this).parents("form").addClass("password_section-active");
      // Check the length of the email variable
      $(this).parents("form").find(".hide_next").hide();
      $(this).parents("form").find(".show_next").show();
      $(".added_email").html(email);
    }
  });

  $(document).on("click", ".identity-box", function () {
    $(this).parents("form").removeClass("password_section-active");
    $(this).parents("form").find(".hide_next").show();
    $(this).parents("form").find(".show_next").hide();
  });
  // login page functionality start

  // ====================================

  // register page functionality start
  var firstNameIsValid = false;
  var lastNameIsValid = false;

  $("input#RegisterForm-FirstName").on("input change", function () {
    var inputText = $(this).val();
    firstNameIsValid = inputText.trim() !== "";
    checkValidation();
  });

  $("input#RegisterForm-LastName").on("input change", function () {
    var inputText = $(this).val();
    lastNameIsValid = inputText.trim() !== "";
    checkValidation();
  });
  $("input#RegisterForm-email").on("input change", function () {
    var inputText = $(this).val();
    EmailIsValid = inputText.trim() !== "";
    checkValidation();
  });
  $("input#RegisterForm-password").on("input change", function () {
    var inputText = $(this).val();
    PasswordIsValid = inputText.trim() !== "";
    checkValidation();
  });

  function checkValidation() {
    if (
      firstNameIsValid &&
      lastNameIsValid &&
      EmailIsValid &&
      PasswordIsValid
    ) {
      $(".submit_btn").removeClass("btn-disabled");
    } else {
      $(".submit_btn").addClass("btn-disabled");
    }
  }

  $(document).on(
    "click",
    "#create_customer .next_step_pass:not('.submit_btn')",
    function () {
      $(".error_message").remove();
      var pattern = /^[a-zA-Z\s.'\u2019]+$/;
      var name = $(this).parents("form").find("#RegisterForm-FirstName").val();
      var last_name = $(this)
        .parents("form")
        .find("#RegisterForm-LastName")
        .val();

      if (name.length > 0 && last_name.length > 0) {
        if (!pattern.test(name)) {
          $(this)
            .parents("form")
            .find("#RegisterForm-FirstName")
            .after(
              '<div class="error_message">Enter a first name with only letters, spaces, periods, and apostrophes</div>'
            );
          $(this).addClass("btn-disabled");
          return;
        }

        if (!pattern.test(last_name)) {
          $(this)
            .parents("form")
            .find("#RegisterForm-LastName")
            .after(
              '<div class="error_message">Enter a first name with only letters, spaces, periods, and apostrophes</div>'
            );
          $(this).addClass("btn-disabled");
          return;
        }

        $("h2.form__message").hide();
        $(".error_message").hide();
        $(".loader_outer").show(); // Show loader when button is clicked
        setTimeout(function () {
          $(".loader_outer").hide(); // Hide loader after 2 seconds
        }, 500);
        $(this).parents("form").find(".hide_next").hide();
        $(this).parents("form").find(".show_next").show();
        $(".step_count").html("2");
      } else {
        $(this).parents("form").find(".hide_next").show();
        $(this).parents("form").find(".show_next").hide(); // Fixed typo 'hibe' to 'hide'
        $(".step_count").html("1");
      }
    }
  );

  $("input#CustomerPassword").on("input change", function () {
    var inputText = $(this).val();
    if (inputText.trim() !== "") {
      $(".login_inside").removeClass("btn-disabled");
    } else {
      $(".login_inside").addClass("btn-disabled");
    }
  });

  $("input#RecoverEmail").on("input change", function () {
    var inputText = $(this).val();
    if (inputText.trim() !== "") {
      $(".recovery_submit").removeClass("btn-disabled");
    } else {
      $(".recovery_submit").addClass("btn-disabled");
    }
  });

  $(".create_account").click(function () {
    $(window).on("beforeunload", function () {
      // Show loader when navigating away from the page
      $(".loader_outer").show();
      setTimeout(function () {
        $(".loader_outer").hide(); // Hide loader after 2 seconds
      }, 500);
    });
  });

  // register page functionality start

  // ====================================

  // for tooltip on login and register page
  $(".email_infor-wrapper").hover(
    function () {
      $(this).addClass("tooltip--opend");
    },
    function () {
      $(this).removeClass("tooltip--opend");
    }
  );

  // ====================================

  // $(".mega-menu").click(function (event) {
  //   event.preventDefault();
  //   // Get the target div id from data-target attribute
  //   var target = $(this).data("li");

  //   $(".layout__heroslide").animate(
  //     {
  //       scrollTop: $("#" + target).offset().top,
  //     },
  //     1000
  //   );
  // });

  // ====================================

  $("#RegisterForm-password").on("input change", function () {
    var password = $(this).val();
    console.log(password);
    var regex =
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}|\\:;"'<>,.?/]).{8,}$/;
    if (regex.test(password)) {
      $(".email_infor-wrapper").addClass("tooltip--opend");
    } else {
      $(".email_infor-wrapper").removeClass("tooltip--opend");
    }

    if (password != "") {
      $(".show_password .show_password-icon").show();
    } else {
      $(".show_password .show_password-icon").hide();
    }
  });

  $(".show_password svg").click(function () {
    var passwordField = $("#RegisterForm-password");
    var currentType = passwordField.attr("type");
    if (currentType === "password") {
      passwordField.attr("type", "text");
      $(".show_password-icon").hide();
      $(".hide_password-icon").show();
    } else {
      passwordField.attr("type", "password");
      $(".show_password-icon").show();
      $(".hide_password-icon").hide();
    }
  });

  //
  $("span.plus_icon, .plus_icon_second").click(function () {
    $(this).toggleClass("cross_icon");
    $(this)
      .parents(".overlay_background")
      .find(".overlay_content")
      .toggleClass("active");
  });
  // ====================================
});

// add-to-cart button js

$(document).ready(function () {
  $(".mandatory_box input[type=radio]").on("click", function () {
    //
    var inputId = $(this).attr("id"); // Get the ID of the clicked input
    var label = $("label[for='" + inputId + "']");
    var show_bottom_section = label.attr("data-present");
    //
    var totalBoxes = $(".mandatory_box").length;
    var checkedBoxes = $(".mandatory_box input[type=radio]:checked").length;
    var button = $(".product-form");
    var customize_box = $(".customize_wrapper");

    var currentIndex = $(".mandatory_box").index(
      $(this).closest(".mandatory_box")
    );
    var prevBoxes = $(".mandatory_box:lt(" + currentIndex + ")");
    if (
      prevBoxes.length === 0 ||
      prevBoxes.find("input[type=radio]:checked").length > 0
    ) {
      var nextBox = $(".mandatory_box").eq(currentIndex + 1);
      if (nextBox.length > 0) {
        nextBox.css({
          opacity: 1,
          "pointer-events": "inherit",
        });
        nextBox.find("input[type=radio]").removeAttr("disabled");
        var var_title = nextBox.find(".model-box-inner").attr("var-title");
        var val_checked = $(".mandatory_box input[type=radio]:checked").val();
        $(".customize_wrapper").attr("var-title", val_checked);
        nextBox.find(".model-box-inner").hide();
        nextBox
          .find(".model-box-inner[var-title='" + val_checked + "']")
          .show();
        // Check if the attribute of the checked radio button in the previous box matches the attribute of the checked radio button in the current box
        var prevCheckedValue = prevBoxes
          .find("input[type=radio]:checked")
          .val();
        var currentCheckedValue = $(this).attr("var-title");
        if (prevCheckedValue === currentCheckedValue) {
          nextBox.addClass("matched-attribute"); // Add CSS class if attributes match
        } else {
          nextBox.removeClass("matched-attribute"); // Remove CSS class if attributes don't match
        }
      }
    }

    if (checkedBoxes === totalBoxes) {
      button.removeAttr("disabled");
      $(".OrderSummary").addClass("final_active");
      $(".still_unsure").addClass("secure_active");
      var var_price = $(
        ".best-model .model-box-inner input[type=radio]:checked"
      )
        .parent()
        .attr("var-price");
      var var_id = $(".best-model .model-box-inner input[type=radio]:checked")
        .parent()
        .attr("var-id");
      $("input.product-variant-id").val(var_id);
      $(".OrderPrice").text(var_price);
      var var_title = $(".product-form__input input[type=radio]:checked").val();
      $(".OrderSummaryTitle h2").text(var_title);
      // customize_box.show("show_customized");
    } else {
      button.attr("disabled", "disabled");
      $(".OrderSummary").removeClass("final_active");
      $(".still_unsure").removeClass("secure_active");
      // customize_box.hide("show_customized");
    }

    if (show_bottom_section == "false") {
      button.removeAttr("disabled");
      $(".OrderSummary").addClass("final_active");
      $(".still_unsure").addClass("secure_active");
      var var_price = $(
        ".best-model .model-box-inner input[type=radio]:checked"
      )
        .parent()
        .attr("var-price");
      $(".OrderPrice").text(var_price);
      var var_title = $(".product-form__input input[type=radio].checked").val();
      $(".OrderSummaryTitle h2").text(var_title);
    }
  });

  // Disable lower boxes initially
  // $(".mandatory_box:gt(0) input[type=radio]").attr("disabled", "disabled");
});

// faq accordin

document.addEventListener("DOMContentLoaded", function () {
  // Get all accordion summaries
  const accordionSummaries = document.querySelectorAll(".accordion summary");

  // Loop through each accordion summary
  accordionSummaries.forEach((summary) => {
    // Add click event listener to each summary
    summary.addEventListener("click", function () {
      // Toggle the 'active' class on the accordion content
      const content = this.nextElementSibling;
      content.classList.toggle("active");
    });
  });
});


$(document).ready(function () {
 $(document).on('click', '.product-form__submit', function(e) {
  e.preventDefault();
 
  var $form = $(this).closest('form'); 
    var $errorWrapper = $('.product-form__error-message-wrapper');
      var $errorMessage = $errorWrapper.find('.product-form__error-message');
           $errorMessage.text('');
          
 
  var variantId = $(".product-variant-id").attr("value");
  var qty = $(".product-form__quantity .quantity__input").val() || 1;

  var data = {
    id: variantId,
    quantity: qty
  };

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(data),
    dataType: 'json',
    contentType: 'application/json',

    success: function(item) {
     window.location.href = "/cart";
    },

    error: function(xhr) {
      console.log("❌ Raw error:", xhr.responseText);

      var message = 'Something went wrong. Please try again.';

      if (xhr.responseText) {
        try {
          var response = JSON.parse(xhr.responseText);
          console.log(response);
          if (response.description) {  
            console.log(response.description);         
            message = response.description;
          } else if (response.message) {
            message = response.message;
          }
        } catch (err) {
          console.log("⚠️ JSON pars eerror:", err);
        }
      }  
      $errorMessage.text(message);
      $errorWrapper.removeAttr('hidden');
    }
  });
});


});

$(document).ready(function () {
  $(".product-v2-button .product-form__submit").click(function (event) {
    // event.preventDefault(); // Prevent default form submission

    var variant_id = $(".product-variant-id").val();
console.log(variant_id);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ id: variant_id, quantity: 1 }), // Convert data to JSON string
      contentType: "application/json", // Set content type to JSON
      success: function (response) {
        window.location.href = "/cart";
      },
      error: function (xhr, status, error) {
        console.error("Error:", xhr, status, error);
      },
    });
  });
});

// Delivery zip code js
document.addEventListener("DOMContentLoaded", function () {
  var button = document.querySelector(".delivery-zip");
  var overlay = document.querySelector(".popup-overlay");
  var closeIcon = document.querySelector(".deliveryclose");
  if (button && overlay && closeIcon) {
    // Check if all elements are found
    button.addEventListener("click", function (event) {
      event.stopPropagation(); // Stop event propagation
      document.body.classList.add("delivery-zip-open");
    });
    closeIcon.addEventListener("click", function (event) {
      event.preventDefault();
      document.body.classList.remove("delivery-zip-open");
    });
    overlay.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation(); // Stop event propagation
      document.body.classList.remove("delivery-zip-open");
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  // Function to set a cookie
  function setCookie(name, value) {
    document.cookie = name + "=" + value + ";path=/";
  }

  // Function to get a cookie value by name
  function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      while (cookie.charAt(0) == " ") {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) == 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }

  // Load the ZIP code from the cookie if available
  var zipCode = getCookie("zipCode");
  if (zipCode) {
    document.getElementById("zip-code-text").innerText = "ZIP Code: " + zipCode;
    document.getElementById("zipcode_properties").value = zipCode;
    document.getElementById("zip-code-input").value = zipCode; // Set input value to stored ZIP code
  }

  // Event listener for form submission
  document
    .getElementById("zip-code-form")
    .addEventListener("submit", function (event) {
      event.preventDefault(); // Prevent form submission

      // Get the value entered in the input field
      var newZipCode = document.getElementById("zip-code-input").value;

      // Load the existing ZIP code from the cookie
      var oldZipCode = getCookie("zipCode");

      // Check if the new ZIP code is different from the old one
      if (newZipCode !== oldZipCode) {
        // Update the ZIP code cookie
        setCookie("zipCode", newZipCode);
        document.getElementById("zipcode_properties").value = newZipCode;
        // Update the text with the entered zip code
        document.getElementById("zip-code-text").innerText =
          "ZIP Code: " + newZipCode;

        // Remove the 'delivery-zip-open' class from the body
        document.body.classList.remove("delivery-zip-open");
      }
    });
  document.addEventListener("DOMContentLoaded", function () {
    var zipCodeInput = document.getElementById("zip-code-input");

    // Add event listener to validate the input on change
    zipCodeInput.addEventListener("input", function () {
      validateZipCode(this);
    });
  });
  function validateForm() {
    var zipCodeInput = document.getElementById("zip-code-input");
    var errorMessage = document.getElementById("error-message");

    // Check if the input value meets the minimum length requirement
    if (zipCodeInput.value.length < 4) {
      // Show error message
      errorMessage.style.display = "block";
      // Prevent form submission
      return false;
    } else {
      // Hide error message
      errorMessage.style.display = "none";
      // Allow form submission
      return true;
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var button = document.querySelector(".seeDetails");
  var overlay = document.querySelector(".info-popup-overlay");
  var closeIcon = document.querySelector(".closeIcon");

  if (button && overlay && closeIcon) {
    // Check if all elements are found
    button.addEventListener("click", function (event) {
      event.stopPropagation(); // Stop event propagation
      document.body.classList.add("info-popup-open");
    });
    closeIcon.addEventListener("click", function (event) {
      event.preventDefault();
      document.body.classList.remove("info-popup-open");
    });
    overlay.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation(); // Stop event propagation
      document.body.classList.remove("info-popup-open");
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var button = document.querySelector(
    ".image_with_inner_second .info_inner_second span"
  );
  var overlay = document.querySelector(".info-popup-overlay");
  var closeIcon = document.querySelector(".closeIcon");

  if (button && overlay && closeIcon) {
    // Check if all elements are found
    button.addEventListener("click", function (event) {
      event.stopPropagation(); // Stop event propagation
      document.body.classList.add("info-popup-open");
    });
    closeIcon.addEventListener("click", function (event) {
      event.preventDefault();
      document.body.classList.remove("info-popup-open");
    });
    overlay.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation(); // Stop event propagation
      document.body.classList.remove("info-popup-open");
    });
  }
});

// help popup js
document.addEventListener("DOMContentLoaded", function () {
  var button = document.querySelector(".add-more");
  var overlay = document.querySelector(".help-popup-overlay");
  var closeIcon = document.querySelector(".helpcloseIcon");
  if (button && overlay && closeIcon) {
    // Check if all elements are found
    button.addEventListener("click", function (event) {
      event.stopPropagation(); // Stop event propagation
      document.body.classList.add("help-popup-open");
    });

    closeIcon.addEventListener("click", function (event) {
      event.preventDefault();
      document.body.classList.remove("help-popup-open");
    });

    overlay.addEventListener("click", function (event) {
      event.preventDefault();
      document.body.classList.remove("help-popup-open");
    });
  }
});
// faq js
document.addEventListener("DOMContentLoaded", function () {
  var faqButton = document.querySelector(".faqButton");
  var faqContent = document.querySelector(".faq-content");
  if (faqButton && faqContent) {
    faqButton.addEventListener("click", function () {
      faqButton.classList.toggle("button-collapse");
      faqContent.classList.toggle("faq-collapse");
    });
  }
});
// language popup js
document.addEventListener("DOMContentLoaded", function () {
  var button = document.querySelector(".lang-panel");
  var overlay = document.querySelector(".language-popup-overlay");
  var closeIcon = document.querySelector(".Panelclose");
  if (button && overlay && closeIcon) {
    // Check if all elements are found
    button.addEventListener("click", function (event) {
      event.stopPropagation(); // Stop event propagation
      document.body.classList.add("language-popup-open");
    });
    closeIcon.addEventListener("click", function (event) {
      event.preventDefault();
      document.body.classList.remove("language-popup-open");
    });
    overlay.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation(); // Stop event propagation
      document.body.classList.remove("language-popup-open");
    });
  }

  const numberInput = document.getElementById("zip-code-input");
  const errorDiv = document.getElementById("error");

  numberInput.addEventListener("input", function () {
    let inputValue = this.value.trim();

    // Remove any characters other than numbers
    inputValue = inputValue.replace(/[^\d]/g, "");

    // Check if input is empty after removing non-numeric characters
    if (inputValue === "") {
      errorDiv.textContent = "Please enter numbers only";
      applyErrorStyles(); // Apply error styles
      return;
    }

    // Check if input contains alphabetic characters
    if (/[a-zA-Z]/.test(inputValue)) {
      errorDiv.textContent = "Alphabetic characters are not allowed";
      this.value = inputValue.replace(/[a-zA-Z]/g, ""); // Remove alphabetic characters from the input
      applyErrorStyles(); // Apply error styles
      return;
    }

    // Clear error styles if input is valid
    clearErrorStyles(); // Clear error styles

    // Check if input length is less than 4 or greater than 6
    if (inputValue.length < 4) {
      errorDiv.textContent = "Number must be at least 4 digits long";
      applyErrorStyles(); // Apply error styles
    } else if (inputValue.length > 6) {
      errorDiv.textContent = "Number must be at most 6 digits long";
      // Trim input value if it exceeds 6 characters
      this.value = inputValue.substring(0, 6);
      applyErrorStyles(); // Apply error styles
    } else {
      errorDiv.textContent = ""; // Clear error message if input is valid
    }
  });

  function applyErrorStyles() {
    numberInput.style.border = "2px solid red"; // Apply red border to input field
    errorDiv.style.color = "red"; // Set error text color to red
    errorDiv.style.fontSize = "11px"; // Set error text font size to 11px
  }

  function clearErrorStyles() {
    numberInput.style.border = ""; // Remove border style
    // Do not remove color and font-size styles for the error message
  }
});
function initializeFlickity() {
  var flickitySliders = document.getElementsByClassName("product-blocks");

  // Enable dragging on mobile view
  if (window.innerWidth <= 768) {
    // Adjust this breakpoint as needed
    for (var i = 0; i < flickitySliders.length; i++) {
      var flkty = new Flickity(flickitySliders[i], {
        draggable: window.innerWidth <= 768,
      });
    }
  }
}

// Call the function on DOMContentLoaded
document.addEventListener("DOMContentLoaded", initializeFlickity);

// Call the function on window resize
window.addEventListener("resize", function () {
  initializeFlickity();
});

// tabs js

function openTab(evt, tabName) {
  var i, tabcontent, tablinks;

  // Hide all tab content
  tabcontent = document.getElementsByClassName("tab-content");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Remove 'active' class from all tab links
  tablinks = document.getElementsByClassName("tablink");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  // Show the selected tab content for all elements with the same tabName
  var selectedTabs = document.getElementsByClassName(tabName);
  for (i = 0; i < selectedTabs.length; i++) {
    selectedTabs[i].style.display = "block";
  }

  // Add 'active' class to the clicked tab link
  evt.currentTarget.classList.add("active");
}

// for footer popups
document.addEventListener("DOMContentLoaded", function () {
  var popupLinks = document.querySelectorAll(".popup_link");

  // Add a click event listener to each 'popup_link' element
  popupLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      // Prevent the default behavior of the link
      event.preventDefault();

      // Get the text content of the clicked link
      var text = this.textContent || this.innerText;

      // Get the popup section with the corresponding data-title attribute
      var popupSections = document.querySelectorAll(".popup_section");

      // Loop through each popup section to find the matching one
      popupSections.forEach(function (section) {
        // Check if the data-title attribute of the section matches the text of the clicked link
        if (section.getAttribute("data-title") === text) {
          // Add the class 'open-popup' to the matching popup section
          section.classList.add("open-popup");
          document.body.classList.add("overlay_background");
        }
      });
    });
  });

  // Close popup when the close button is clicked
  document.querySelectorAll(".popup-close").forEach(function (closeButton) {
    closeButton.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent event from bubbling up
      closePopup();
    });
  });

  // Function to close the popup
  function closePopup() {
    var popupSections = document.querySelectorAll(".popup_section");
    popupSections.forEach(function (section) {
      section.classList.remove("open-popup");
    });
    document.body.classList.remove("overlay_background");
  }

  // Close popup when clicking outside of it
  document.addEventListener("click", function (event) {
    // Check if the click target is outside the popup content area
    if (
      !event.target.closest(".page_inner_content") &&
      !event.target.closest(".popup_link")
    ) {
      closePopup(); // Close the popup
    }
  });
});



// function closePopupOutside(event) {
//   var popup = $(".popup_section");
//   var targetElement = $(event.target);

//   if (!popup.is(targetElement) && !targetElement.is(".popup_link")) {
//     popup.removeClass("open-popup");
//     $(document).off("click", closePopupOutside);
//   }
// }

// $(document).ready(function () {
//   $(".popup_link").click(function (e) {
//     if ($(window).width() > 767) {
//       e.preventDefault();
//       var currentText = jQuery(this).text();
//       if (currentText == "Contact us") {
//         currentText = currentText.replace(" us", "");
//       }
//       jQuery(".popup_section").each(function () {
//         var datatitle = jQuery(this).attr("data-title");
//         if (currentText == datatitle || currentText == "Contact us ") {
//           $(this).addClass("open-popup");
//           $(document).on("click", closePopupOutside);
//         }
//       });
//     } else {
//       window.location.href = jQuery(this).closest("a").attr("href");
//     }
//   });
// });
$(document).ready(function () {
  $(".learn_more").click(function () {
    $(".gurranty_page").show();
    $("body").addClass("open-gurranty-popup");
  });

  $(".popup_close").click(function () {
    closePopup();
  });

  // Close popup when clicking outside of it
  $(document).click(function (event) {
    if (!$(event.target).closest(".gurranty_page, .learn_more").length) {
      closePopup();
    }
  });

  // Function to close popup
  function closePopup() {
    $("body").removeClass("open-gurranty-popup");
    $(".gurranty_page").hide();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".product__media-item");
  const thumbnails = document.querySelectorAll(".thumbnail-list__item");
  let currentIndex = 0;

  function showItem(index) {
    items.forEach((item, idx) => {
      if (idx === index) {
        item.classList.add("is-active");
      } else {
        item.classList.remove("is-active");
      }
    });

    const activeItem = items[index];
    const targetValue = activeItem.getAttribute("data-media-id");

    thumbnails.forEach((thumbnail) => {
      const button = thumbnail.querySelector(".thumbnail"); // Select the button inside the thumbnail
      if (thumbnail.getAttribute("data-target") === targetValue) {
        button.setAttribute("aria-current", "true"); // Set aria-current on the button
      } else {
        button.removeAttribute("aria-current"); // Remove aria-current from the button
      }
    });
  }

  function showNextItem() {
    currentIndex = (currentIndex + 1) % items.length;
    showItem(currentIndex);
  }

  function showPrevItem() {
    currentIndex = (currentIndex - 1 + items.length) % items.length;
    showItem(currentIndex);
  }

  document.querySelector(".nextBtn").addEventListener("click", showNextItem);
  document.querySelector(".prevBtn").addEventListener("click", showPrevItem);

  // Initialize the first item as active
  showItem(currentIndex);
});

document.addEventListener("scroll", () => {
  const sections = document.querySelectorAll(".heroslide-parallax");
  let scrollPosition = window.scrollY + window.innerHeight / 8;
  let currentSectionId = null;

  sections.forEach((section) => {
    const sectionRect = section.getBoundingClientRect();
    const sectionTop = sectionRect.top + window.scrollY + 100;
    const sectionHeight = sectionRect.height;

    if (
      scrollPosition >= sectionTop &&
      scrollPosition < sectionTop + sectionHeight
    ) {
      currentSectionId = section.id;
    }
  });

  if (currentSectionId) {
    if (!document.body.classList.contains(currentSectionId)) {
      document.body.classList.add(currentSectionId);
    }
  }

  sections.forEach((section) => {
    if (section.id !== currentSectionId) {
      document.body.classList.remove(section.id);
    }
  });
});

// tyrecontrol Air v2

// $(document).ready(function(){

//   const radioInputs = document.querySelectorAll('input[name="Model"]');
//   const orderSummaryTitle = document.querySelector(".OrderSummaryTitle h2");

//   const orderSummaryPrice = document.querySelector(".OrderSummaryTitle .OrderPrice");
//   const productFormButtons = document.querySelector(".product-form__buttons");
//   const Description = document.querySelector("#combined-lead-time");
//   const OrderSummary = document.querySelector(".OrderSummary");

//   function updateOrderSummary() {

//     const checkedInput = document.querySelector('input[name="Model"]:checked');

//     if (checkedInput) {
//       const selectedBox = checkedInput.closest(".model-box-outer");
//       const selectedLabel = selectedBox.querySelector(".model-box-left");
//        const selectedDesc = selectedBox.querySelector(".description-variant").innerHTML;

//       const selectedPrice = selectedBox.querySelector(".model-box-right p").textContent.trim();

//       const newHeading = selectedLabel.firstChild.textContent.trim();

//       orderSummaryTitle.textContent = newHeading;
//       orderSummaryPrice.textContent = selectedPrice.replace("From ", "");
//     Description.textContent = selectedDesc;
//       // Add the 'active' class to product-form__buttons when any radio is checked
//       productFormButtons.classList.add("active");
//       OrderSummary.classList.add("active");
//     }

// // Get input value

// const listItems = document.querySelectorAll(".thumbnail-list li");
// // const OuterlistItems = document.querySelectorAll(".outer-thumbnail-list li");

// listItems.forEach((li, index) => {
//   const img = li.querySelector('img');
//   if (img) {
//     const image_tag = img.alt;
//     if (image_tag === checkedInput.value) {
//      li.style.display = 'block';
//     }else{
//         li.style.display = 'none';
//     }
//   }
// });

// // OuterlistItems.forEach((li, index) => {
// //   const image = li.querySelector('img');
// //   if (img) {
// //     const image__tag = image.alt;
// //     if (image__tag === checkedInput.value) {
// //      li.style.display = 'block';
// //     }else{
// //         li.style.display = 'none';
// //     }
// //   }
// // });

//   }

//   radioInputs.forEach(input => {
//     input.addEventListener("change", updateOrderSummary);
//   });
// });
$(document).ready(function () {
  const radioInputs = document.querySelectorAll('input[name="Model"]');
  const orderSummaryTitle = document.querySelector(".OrderSummaryTitle h2");
  const orderSummaryPrice = document.querySelector(
    ".OrderSummaryTitle .OrderPrice"
  );
  const productFormButtons = document.querySelector(".product-form__buttons");
  const Description = document.querySelector("#combined-lead-time");
  const OrderSummary = document.querySelector(".OrderSummary");

  function updateOrderSummary() {
    const checkedInput = document.querySelector('input[name="Model"]:checked');

    if (checkedInput) {
      const selectedBox = checkedInput.closest(".model-box-outer");
      const selectedLabel = selectedBox.querySelector(".model-box-left");
      const selectedDesc = selectedBox.querySelector(
        ".description-variant"
      ).innerHTML;
      const selectedPrice = selectedBox
        .querySelector(".model-box-right p")
        .textContent.trim();
      const newHeading = selectedLabel.firstChild.textContent.trim();

      orderSummaryTitle.textContent = newHeading;
      orderSummaryPrice.textContent = selectedPrice.replace("From ", "");
      Description.textContent = selectedDesc;

      // Add the 'active' class to product-form__buttons when any radio is checked
      productFormButtons.classList.add("active");
      OrderSummary.classList.add("active");

      // Save the selected variant to local storage
      localStorage.setItem("selectedVariant", checkedInput.value);
    }

    // Update images based on the selected variant
    const listItems = document.querySelectorAll(".thumbnail-list li");

    listItems.forEach((li, index) => {
      const img = li.querySelector("img");
      if (img) {
        const image_tag = img.alt;
        if (image_tag === checkedInput.value) {
          li.style.display = "block";
        } else {
          li.style.display = "none";
        }
      }
    });
  }

  // Load the selected variant from local storage when the page loads
  const savedVariant = localStorage.getItem("selectedVariant");
  if (savedVariant) {
    const savedInput = document.querySelector(
      `input[name="Model"][value="${savedVariant}"]`
    );
    if (savedInput) {
      savedInput.checked = true;
      updateOrderSummary(); // Trigger the update based on the saved variant
    }
  }

  // Add event listeners for the radio inputs
  radioInputs.forEach((input) => {
    input.addEventListener("change", updateOrderSummary);
  });
});


/*=================================================*/
$(document).on('click', '.model-box-inner', function() {
    console.log('Clicked:', $(this)); // Log the clicked element

    // Get the value of the data-custom attribute from the clicked model-box-inner
    var dataCustom = $(this).attr('data-custom');
    console.log('Data Custom:', dataCustom);

    // Loop through each product__media div
    $('.product__media').each(function() {
        // Get the value of the image-alt attribute
        var imageAlt = $(this).attr('image-alt');
        
        // Log the image-alt value for debugging
        console.log('Image Alt:', imageAlt);
        
        // Compare values
        if ($.trim(imageAlt) === $.trim(dataCustom)) {
            // If there's a match, perform your desired action
            console.log('Match found:', imageAlt);
            // Example: Update the main image
            $('#mainProductImage').html($(this).html()); // Update the main product image
            $('#mainProductImage').attr('alt', imageAlt); // Update the alt attribute of the main image
        }
    });
});
/*=================================================*/



/*======================Sold out button script===========================*/
document.addEventListener("DOMContentLoaded", function() {
  const radios = document.querySelectorAll(".bundle-radio");
  if (radios.length === 0) return; // Exit if no bundle radios

  radios.forEach(radio => {
    radio.addEventListener("change", function() {
      const parent = this.closest(".model-box-inner");
      const form = this.closest("form");
      if (!parent || !form) return;

      const variantIdInput = form.querySelector(".product-variant-id");
      const variantInvInput = form.querySelector(".product-variant-inv");
      const submitButton = form.querySelector(".product-form__submit");

      if (variantIdInput) variantIdInput.value = parent.getAttribute("var-id") || "";
      if (variantInvInput) variantInvInput.value = parent.getAttribute("var-invent") || "false";

      // Toggle button only for this form
      if (variantInvInput && submitButton) {
        const inStock = variantInvInput.value === "true";
        const btnText = submitButton.querySelector("span");

        if (!inStock) {
          submitButton.disabled = true;
          submitButton.classList.add("disabled");
          if (btnText) btnText.textContent = "Sold Out";
        } else {
          submitButton.disabled = false;
          submitButton.classList.remove("disabled");
          if (btnText) btnText.textContent = "BUY NOW";
        }
      }
    });
  });

  // Run initial check for the first selected radio in each form
  radios.forEach(radio => {
    const parent = radio.closest(".model-box-inner");
    const form = radio.closest("form");
    if (!parent || !form) return;

    const variantIdInput = form.querySelector(".product-variant-id");
    const variantInvInput = form.querySelector(".product-variant-inv");
    const submitButton = form.querySelector(".product-form__submit");

    if (variantIdInput) variantIdInput.value = parent.getAttribute("var-id") || "";
    if (variantInvInput) variantInvInput.value = parent.getAttribute("var-invent") || "false";

    if (variantInvInput && submitButton) {
      const inStock = variantInvInput.value === "true";
      const btnText = submitButton.querySelector("span");

      if (!inStock) {
        submitButton.disabled = true;
        submitButton.classList.add("disabled");
        if (btnText) btnText.textContent = "Sold Out";
      } else {
        submitButton.disabled = false;
        submitButton.classList.remove("disabled");
        if (btnText) btnText.textContent = "BUY NOW";
      }
    }
  });
});

